import { createFetcher } from '../contexts/Fetcher';
import { apiDocumentation } from '../resources/api/apiDocumentation';
import { useContext } from 'react';
import { OrganizationContext } from '../contexts/OrganizationContext';

const { useDocumentationList } = apiDocumentation;

export const DocumentationFetcher = createFetcher(() => {
  const { organization } = useContext(OrganizationContext);
  const { execute } = useDocumentationList(organization ?? void 0);
  return execute;
});
